<template>
  <div>
    <search-nav @handleSearch="handleClickSearch">
      <search-nav-item-select name="year" label="연도" v-model="nav.searchYear" :list="selectYearOptions" />
      <search-nav-item-select name="type" label="구분" v-model="nav.searchType" :list="searchTypes" />
      <search-nav-item-select name="typefilter" label="" v-model="nav.searchTypeFilter" :list="searchTypeFilters" style="width: 300px !important" />
    </search-nav>
    <vx-card>
      <h5 class="mb-4"><i class="dot"></i> 안전보건 점검 미이행 세부 현황</h5>
      <vs-tabs v-if="1 < tabOptions.length" :value="tabIndex"> <vs-tab v-for="tab in tabOptions" :key="`tab_${tab}`" :label="tab" @click="moveTab(tab)"></vs-tab></vs-tabs>
      <!-- CONTENT -->
      <div class="content-container">
        <!-- HEAD -->
        <div class="flex items-center justify-start gap-2 mb-3">
          <vs-select autocomplete v-model="nav.perPage" style="width: 140px">
            <vs-select-item v-for="_perPage in perPageOpstions" :key="`perpage_${_perPage}`" :text="`${_perPage}개씩 보기`" :value="_perPage" />
          </vs-select>
          <FilterButton
            :typeOptions="['기계공학과', '토목공학과', '건축공학과', '법학과', '특수학교', '각종학교', '본청', '직속(분원)', '교육지원청(공공도서관)']"
            :addOptions="['휴게시설', '급식종사자', '당직업무', '통학보조', '시설관리', '미화원', '물질 안전·보건자료']"
            v-model="nav.filter"
          />

          <SearchNavItemKeyword :viewLabel="true" label="학교(기관)명" v-model="nav.searchKeyword" class="ml-auto" />
        </div>
        <!-- TABLE -->
        <table>
          <colgroup>
            <col width="100" />
            <col />
            <col />
          </colgroup>
          <thead>
            <tr>
              <th>No.</th>
              <th>구분</th>
              <th>학교(기관)명</th>
              <th>휴게시설</th>
              <th>급식종사자</th>
              <th>당직업무</th>
              <th>통학보조</th>
              <th>시설관리</th>
              <th>미화원</th>
              <th>물질 안전·보건자료</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, row_i) in tableRows" :key="row.id">
              <td>{{ (nav.currentPage - 1) * nav.perPage + row_i + 1 }}</td>
              <td>{{ row.category }}</td>
              <td>{{ row.field_name }}</td>
              <td><ColorCircleData :value="false" label="2회/4회" /></td>
              <td><ColorCircleData :value="true" label="2회/4회" /></td>
              <td><ColorCircleData :value="false" label="2회/4회" /></td>
              <td><ColorCircleData :value="false" label="2회/4회" /></td>
              <td><ColorCircleData :value="false" label="2회/4회" /></td>
              <td><ColorCircleData :value="false" label="2회/4회" /></td>
              <td><ColorCircleData :value="false" label="2회/4회" /></td>
            </tr>
          </tbody>
        </table>

        <!-- PAGINATION -->
        <div class="vs-con-table mt-10">
          <div class="con-pagination-table vs-table--pagination">
            <k-pagination :total="nav.total" :perPage="nav.perPage" :max-items="5" v-model="nav.currentPage"></k-pagination>
          </div>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import SearchNav from "@/components/nav/SearchNav.vue";
import SearchNavItemSelect from "@/components/nav/SearchNavItemSelect";
import SearchNavItemKeyword from "@/components/nav/SearchNavItemKeyword";
import FilterButton from "./components/FilterButton/FilterButton.vue";
import ColorCircleData from "./components/ColorCircleData.vue";
import KPagination from "@/components/kPagination/kPagination";
import moment from "moment";

export default {
  components: {
    SearchNav,
    SearchNavItemSelect,
    SearchNavItemKeyword,
    FilterButton,
    ColorCircleData,
    KPagination,
  },
  data() {
    return {
      nav: {
        created_at: "",
        searchYear: moment().format("YYYY"),
        searchType: "",
        searchTypeFilter: "",
        searchKeyword: "",

        filter: [{ type: "type", value: ["기계공학과", "토목공학과", "건축공학과", "법학과", "특수학교", "각종학교", "본청", "직속(분원)", "교육지원청(공공도서관)"] }],

        perPage: 50,
        currentPage: 1,
        total: 100,
      },
      searchTypes: [{ value: "전체" }, { value: "반기" }, { value: "분기" }, { value: "월" }, { value: "일" }],
      tabIndex: 0,
      talbeDatas: [],
      allSeries: {
        '전체': [],
        '휴게시설': [],
        '급식종사자': [],
        '당직업무': [],
        '통학보조': [],
        '시설관리': [],
        '미화원': [],
        '물질 안전·보건자료': [],
      },
      targetFacilityCategory: ['기계공학과', '토목공학과', '건축공학과', '법학과'],
      fieldList: [],
      facilityCategoryByFieldId: {},
    };
  },
  computed: {
    // 선택 가능한 연도 값은 2020년부터 내년까지
    selectYearOptions() {
      const years = [];
      const startYear = 2020;
      const endYear = new Date().getFullYear() + 1;
      for (let i = startYear; i <= endYear; i++) {
        years.push(i);
      }
      return years.reverse().map((year) => ({ value: year }));
    },
    searchTypeFilters() {
      let returnData = [];

      if (this.nav.searchType === "전체") returnData = [{ value: "전체" }];
      else if (this.nav.searchType === "반기") returnData = [{ value: "상반기" }, { value: "하반기" }];
      else if (this.nav.searchType === "분기") returnData = [{ value: "1분기" }, { value: "2분기" }, { value: "3분기" }, { value: "4분기" }];
      else if (this.nav.searchType === "월") {
        // 1~12월
        const months = [];
        for (let i = 1; i <= 12; i++) {
          months.push(i);
        }
        returnData = months.map((month) => ({ value: `${month}월` }));
      } else if (this.nav.searchType === "일") {
        // 1~31일
        const days = [];
        for (let i = 1; i <= 31; i++) {
          days.push(i);
        }
        returnData = days.map((day) => ({ value: `${day}일` }));
      }

      if (returnData.length > 0) this.nav.searchTypeFilter = returnData[0].value;
      return returnData;
    },
    // Content Tab Items
    tabOptions() {
      return ["전체", "휴게시설", "급식종사자", "당직업무", "통학보조", "시설관리", "미화원", "물질 안전·보건자료"];
    },
    perPageOpstions() {
      return [50, 100, 200, 500, 1000];
    },
    tableRows() {
      // this.fieldList 항목들을 field_name 기준으로 오름차순 정렬한다
      const sortedFieldList = this.fieldList.sort((a, b) => {
        if (a.field_name < b.field_name) return -1;
        if (a.field_name > b.field_name) return 1;
        return 0;
      });

      // sortedFiedList에서, 현재 페이지에 해당하는 데이터만 추출한다
      const start = (this.nav.currentPage - 1) * this.nav.perPage;
      const end = start + this.nav.perPage;
      const currentFieldList = sortedFieldList.slice(start, end);

      console.log(currentFieldList);

      return currentFieldList;
    }
  },
  mounted() {
    this.loadApi();
  },
  methods: {
    // 검색 버튼 클릭
    handleClickSearch() {
      console.log("handleClickSearch");
    },
    // 탭 이동
    moveTab(data) {
      console.log(data);
    },
    extractQuarterData(yearData) {
      const quarterData = [];
      for (let i = 0; i < 4; i++) {
        quarterData.push([]);
      }
      let month = 0;
      for (const monthData of yearData) {
        if (month === 0) {
          month += 1;
          continue;
        }
        const quarter = Math.floor((month - 1) / 3);
        for (const fieldId of monthData) {
          quarterData[quarter].push(fieldId);
        }

        month += 1;
      }

      // quaterData 각 아이템의 중복 제거
      for (let i = 0; i < 4; i++) {
        quarterData[i] = [...new Set(quarterData[i])];
      }

      return quarterData;
    },
    async loadApi() {
      const data = await this.$store.dispatch('summary/LOAD_FIELD_NOT_PERFORMED_HS', {
        projectIds: [6],
      });
      console.log('data', data);

      this.fieldList = data.fields;

      for (const field of this.fieldList) {
        let cat3 = field.facility_category ? field.facility_category.cat3 : '기타';
        if (!this.targetFacilityCategory.includes(cat3)) {
          cat3 = '기타';
        }
        field.category = cat3;
        this.facilityCategoryByFieldId[field.id] = cat3;
      }

      // 마지막 페이지 번호
      this.nav.total = Math.ceil(this.fieldList.length / this.nav.perPage);

      const currentYear = new Date().getFullYear();

      // 전체
      const allData = data.notPerformedFieldIds.all[currentYear];
      this.allSeries['전체'] = this.extractQuarterData(allData);

      // 급식종사자
      const data519 = {};
      data519['급식종사자'] = data.notPerformedFieldIds['519']['급식종사자'][currentYear];
      this.allSeries['급식종사자'] = this.extractQuarterData(data519['급식종사자']);
      data519['당직업무'] = data.notPerformedFieldIds['519']['당직업무'][currentYear];
      this.allSeries['당직업무'] = this.extractQuarterData(data519['당직업무']);
      data519['통학보조'] = data.notPerformedFieldIds['519']['통학보조'][currentYear];
      this.allSeries['통학보조'] = this.extractQuarterData(data519['통학보조']);
      data519['시설관리'] = data.notPerformedFieldIds['519']['시설관리'][currentYear];
      this.allSeries['시설관리'] = this.extractQuarterData(data519['시설관리']);
      data519['미화원'] = data.notPerformedFieldIds['519']['미화원'][currentYear];
      this.allSeries['미화원'] = this.extractQuarterData(data519['미화원']);

      // 휴게시설
      const data438 = data.notPerformedFieldIds['438'][currentYear];
      this.allSeries['휴게시설'] = this.extractQuarterData(data438);

      // 물질 안전·보건자료
      const data490 = data.notPerformedFieldIds['490'][currentYear];
      this.allSeries['물질 안전·보건자료'] = this.extractQuarterData(data490);

      for (const field of this.fieldList) {
        field.count = [];
        field.count['전체'] = 0;
        field.count['급식종사자'] = 0;
        field.count['당직업무'] = 0;
        field.count['통학보조'] = 0;
        field.count['시설관리'] = 0;
        field.count['미화원'] = 0;
        field.count['휴게시설'] = 0;
        field.count['물질 안전·보건자료'] = 0;
        for (let i = 0; i < 4; i++) {
          const quarterAllFieldIds = this.allSeries['전체'][i];
          if (quarterAllFieldIds.includes(field.id)) {
            field.count['전체'] += 1;
          }
          const quarter519FieldIds = this.allSeries['급식종사자'][i];
          if (quarter519FieldIds.includes(field.id)) {
            field.count['급식종사자'] += 1;
          }
          const quarter519FieldIds2 = this.allSeries['당직업무'][i];
          if (quarter519FieldIds2.includes(field.id)) {
            field.count['당직업무'] += 1;
          }
          const quarter519FieldIds3 = this.allSeries['통학보조'][i];
          if (quarter519FieldIds3.includes(field.id)) {
            field.count['통학보조'] += 1;
          }
          const quarter519FieldIds4 = this.allSeries['시설관리'][i];
          if (quarter519FieldIds4.includes(field.id)) {
            field.count['시설관리'] += 1;
          }
          const quarter519FieldIds5 = this.allSeries['미화원'][i];
          if (quarter519FieldIds5.includes(field.id)) {
            field.count['미화원'] += 1;
          }
          const quarter438FieldIds = this.allSeries['휴게시설'][i];
          if (quarter438FieldIds.includes(field.id)) {
            field.count['휴게시설'] += 1;
          }
          const quarter490FieldIds = this.allSeries['물질 안전·보건자료'][i];
          if (quarter490FieldIds.includes(field.id)) {
            field.count['물질 안전·보건자료'] += 1;
          }
        }
      }

      console.log('allSeries', this.allSeries)
    }
  },
};
</script>

<style lang="scss" scoped>
table {
  table-layout: fixed;
  width: 100%;
  border-collapse: collapse;

  th,
  td {
    font-size: 14px;
    font-weight: 400;
    text-align: center;

    border: 1px solid #cdcdcd;
    padding: 6px;
  }

  th {
    font-weight: 500;
    background: #fafafa;
    padding: 18px 0;
  }
}
</style>
